// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__prD3M","top":"styles_top__ciobq","left":"styles_left__1STZd","description":"styles_description__1O53y"};